const GEDImportManager = () => import('@/modules/SuperAdmin/GEDImportManager')
const GEDImportDrawer = () => import('@/components/SuperAdmin/GEDImport/GEDImportDrawer')

export default [
	{
		component: GEDImportManager,
		name: 'sa-ged-import',
		path: 'ged-import',
		props: false,
		children : [
			{
				component: GEDImportDrawer,
				name: 'sa-create-ged-import',
				path: 'create'
			}
		]
	}
]
